export enum ERoute {
  accessDenied = 'access-denied',
  account = 'account',
  admin = 'admin',
  app = 'app',
  banner = 'banner',
  checkout = 'checkout',
  cms = 'cms',
  configuration = 'configuration',
  corporateDesign = 'corporate-design',
  delete = 'delete',
  onDemandTicketConfiguration = 'on-demand-ticket-configuration',
  directTicketConfiguration = 'ticket-configuration',
  directTickets = 'direct-tickets',
  edit = 'edit',
  error = 'error',
  footer = 'footer',
  general = 'general',
  header = 'header',
  images = 'images',
  incidents = 'incident-monitor',
  info = 'info',
  languages = 'languages',
  mask = 'mask',
  options = 'options',
  orders = 'orders',
  passengerData = 'passenger-data',
  payment = 'payment',
  personalData = 'personal-data',
  reservation = 'reservation',
  salutations = 'salutations',
  shoppingCart = 'shopping-cart',
  sortiment = 'sortiment',
  startPage = 'start-page',
  subscriptionConfiguration = 'subscription-configuration',
  subscriptions = 'subscription-tickets',
  texts = 'texts',
  ticketOwnerData = 'ticket-owner-data',
  userFeedback = 'user-feedback',
  users = 'users',
  web = 'web',
  ticketCategories = 'ticket-categories',
  fellowTravelers = 'fellow-travelers',
  license = 'license',
  appearance = 'appearance',
}
